export default __webpack_public_path__ + "static/0260-94ec10577382f8023529541e4cf0a6a4.png";